import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialRegistration = () => {
  const socialOptions = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'var(--color-error)'
    },
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'Facebook',
      color: '#1877F2'
    },
    {
      id: 'apple',
      name: 'Apple',
      icon: 'Apple',
      color: 'var(--color-foreground)'
    }
  ];

  const handleSocialSignup = (provider) => {
    console.log(`Signing up with ${provider}`);
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center">
          <span className="bg-card px-4 caption text-muted-foreground">Or continue with</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {socialOptions?.map((option) => (
          <Button
            key={option?.id}
            variant="outline"
            size="default"
            onClick={() => handleSocialSignup(option?.id)}
            className="w-full"
          >
            <Icon name={option?.icon} size={20} color={option?.color} />
            <span className="ml-2">{option?.name}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialRegistration;